import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const CHAT_SIDE_PANEL_NAME = 'chatSidePanel';

/**
 * Panneau latéral droit qui héberge le contenu de la page Chat (<chat>),
 * ouvert depuis le bouton chat de la toolbar (GOD only). Même pattern que
 * QuickOrderPanelService : isOpen$ retarde le rendu du contenu à l'ouverture.
 */
@Injectable({ providedIn: 'root' })
export class ChatSidePanelService {
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  toggle(): void {
    const sidebar = this._fuseSidebarService.getSidebar(CHAT_SIDE_PANEL_NAME);
    if (!sidebar) {
      return;
    }
    if (sidebar.opened) {
      this.close();
    } else {
      this._isOpen$.next(true);
      // Laisser le *ngIf monter le contenu avant d'animer l'ouverture.
      setTimeout(() => sidebar.open());
    }
  }

  close(): void {
    this._fuseSidebarService.getSidebar(CHAT_SIDE_PANEL_NAME)?.close();
    this._isOpen$.next(false);
  }
}
